/** Destaca em amarelo os trechos da string `text` que casam com `query`.
 * Para CPF: compara dígito-por-dígito com os dígitos de query (ignora pontuação). */
export default function Highlight({ text, query, cpfMode = false }) {
  const str = String(text ?? "");
  if (!query) return <>{str}</>;
  if (cpfMode) {
    const qDigits = query.replace(/\D/g, "");
    if (!qDigits || qDigits.length < 2) return <>{str}</>;
    const digitPositions = [];
    for (let i = 0; i < str.length; i++) {
      if (/\d/.test(str[i])) digitPositions.push(i);
    }
    const digitsOnly = digitPositions.map((i) => str[i]).join("");
    const hit = digitsOnly.indexOf(qDigits);
    if (hit < 0) return <>{str}</>;
    const startChar = digitPositions[hit];
    const endChar = digitPositions[hit + qDigits.length - 1];
    return (
      <>
        {str.slice(0, startChar)}
        <mark className="bg-yellow-200 text-slate-900 rounded-sm px-0.5">{str.slice(startChar, endChar + 1)}</mark>
        {str.slice(endChar + 1)}
      </>
    );
  }
  const idx = str.toLowerCase().indexOf(query.toLowerCase());
  if (idx < 0) return <>{str}</>;
  return (
    <>
      {str.slice(0, idx)}
      <mark className="bg-yellow-200 text-slate-900 rounded-sm px-0.5">{str.slice(idx, idx + query.length)}</mark>
      {str.slice(idx + query.length)}
    </>
  );
}
